import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import FreeDayHeroImg from '../../asset/FreeDayHeroImg.webp';
import DownArrow from '../../asset/DownArrow.png';

export const FreePassHero = () => {
  const location = useLocation();
  const topMargin = location.pathname === '/free-day-pass' ? '65px' : '120px';
  const arrowRef = useRef(null);

  useEffect(() => {
    const arrow = arrowRef.current;

    gsap.to(arrow, {
      y: 15,
      duration: 1,
      repeat: -1,
      yoyo: true,
      ease: "power1.inOut"
    });
  }, []);

  const scrollToBookATour = () => {
    const element = document.getElementById('book-a-tour');
    if (element) {
      const headerHeight = 65;
      const elementPosition = element.offsetTop - headerHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section
      style={{
        backgroundImage: `url(${FreeDayHeroImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        marginTop: topMargin,
        width: '100%',
        height: 'calc(100vh - 55px)',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      className="px-4 sm:px-8 lg:px-[65px]"
    >
      {/* Claim Now Button */}
      <button
        onClick={scrollToBookATour}
        className="absolute text-white font-sans text-[16px] mb-4 bottom-20 px-8 py-2 bg-gradient-to-r from-[#ff9807] to-[#eab437] text-black font-semibold rounded-full shadow-lg hover:from-[#ffb300] hover:to-[#ffa000] transition-all duration-200" >
        Secure My Seat
      </button>
      <img
        onClick={scrollToBookATour}
        ref={arrowRef}
        className='h-[30px] w-[30px] absolute bottom-12 cursor-pointer'
        src={DownArrow}
        alt="Scroll down arrow"
      />
    </section>
  );
};
